import React, { forwardRef } from 'react'

import { OTPInput, REGEXP_ONLY_DIGITS } from 'input-otp'
import { useController } from 'react-hook-form'

import { mergeRefs } from 'Utils/index'

import ErrorMessage from 'Components/ErrorMessage'
import FormErrors from 'Components/FormErrors'

import { OtpSlots } from './OtpSlots'

const OTP_LENGTH = 6

const otpValidationRules = {
  required: false,
  minLength: {
    value: 6,
    message: 'Enter the 6-digit code',
  },
  pattern: /\d{6}/,
}

interface Props {
  canAutoSubmit: boolean
  onSubmit: () => void
}

export const Code = forwardRef<HTMLInputElement, Props>(({ canAutoSubmit, onSubmit }, ref) => {
  const { field, meta } = useController({ name: 'code', defaultValue: '', rules: otpValidationRules })

  return (
    <div className="user-profile-login__field-group">
      <div className="form-group mb-2">
        <label className="sr-only" htmlFor="profile-login-code">
          Verification code
        </label>
        <OTPInput
          {...field}
          ref={mergeRefs(ref, field.ref)}
          aria-describedby={meta.invalid ? 'profile-login-code-error' : undefined}
          aria-invalid={meta.invalid}
          autoComplete="one-time-code"
          className="user-profile-login__otp-input"
          containerClassName="user-profile-login__otp"
          id="profile-login-code"
          inputMode="numeric"
          maxLength={OTP_LENGTH}
          pattern={REGEXP_ONLY_DIGITS}
          render={({ slots }) => <OtpSlots slots={slots} />}
          spellCheck={false}
          type="text"
          onComplete={() => {
            if (!canAutoSubmit) return
            onSubmit()
          }}
        />
        <ErrorMessage as={FormErrors} id="profile-login-code-error" name="code" />
      </div>
    </div>
  )
})

Code.displayName = 'Code'
